import { render, staticRenderFns } from "./learning-profile-confirmation.vue?vue&type=template&id=33c9c4b1&scoped=true&"
import script from "./learning-profile-confirmation.vue?vue&type=script&lang=js&"
export * from "./learning-profile-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./learning-profile-confirmation.vue?vue&type=style&index=0&id=33c9c4b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9c4b1",
  null
  
)

export default component.exports